import './Disclosure.css';

import {
  Button,
  Disclosure as AriaDisclosure,
  DisclosurePanel,
  DisclosureProps as AriaDisclosureProps,
  Heading,
} from 'react-aria-components';

import { ChevronRight } from '@/primitives/Icons';

export interface DisclosureProps extends Omit<AriaDisclosureProps, 'children'> {
  title?: string;
  children?: React.ReactNode;
  level?: number;
}

export function Disclosure({
  title,
  level,
  children,
  ...props
}: DisclosureProps) {
  return (
    <AriaDisclosure {...props}>
      <Heading level={level}>
        <Button slot="trigger">
          <ChevronRight />
          {title}
        </Button>
      </Heading>
      <DisclosurePanel>{children}</DisclosurePanel>
    </AriaDisclosure>
  );
}
